<template>
  <div class="kpi-row">
    <KpiCard label="Ocupación" :value="occupancyLabel" :sublabel="occupancySublabel" to="/Contratos" />
    <KpiCard label="Ingresos del periodo" :value="incomeLabel" to="/Finanzas" />
    <KpiCard label="Cartera vencida" :value="overdueLabel" to="/Cobranza" />
    <KpiCard label="Tickets abiertos" :value="kpis?.openTickets ?? '—'" to="/Mantenimiento" />
    <KpiCard label="Tasa de Cobranza" :value="collectionRateLabel" to="/Cobranza" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import KpiCard from './KpiCard.vue'

const props = defineProps({
  kpis: { type: Object, default: null },
})

const occupancyLabel = computed(() => {
  if (!props.kpis) return '—'
  const { occupied, total } = props.kpis.occupancy
  if (total === 0) return '0%'
  return `${Math.round((occupied / total) * 100)}%`
})

const occupancySublabel = computed(() => {
  if (!props.kpis) return ''
  const { occupied, total } = props.kpis.occupancy
  return `${occupied}/${total} naves`
})

const incomeLabel = computed(() => formatCurrency(props.kpis?.income.amount))
const overdueLabel = computed(() => formatCurrency(props.kpis?.overdueBalance))

function formatCurrency(amount) {
  if (amount === undefined) return '—'
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    maximumFractionDigits: 0,
  }).format(amount)
}
const collectionRateLabel = computed(() => {
  if (!props.kpis || props.kpis.collectionRate === null) return '—'
  return `${props.kpis.collectionRate.toFixed(1)}%`
})
</script>

<style scoped>
.kpi-row {
  display: flex;
  gap: 1rem;
  padding: 1.5rem 2rem 0;
}
</style>